// extracted by mini-css-extract-plugin
export default {"mobileLayout":"mobileLayout__1Si-n","mobileLayoutContent":"mobileLayoutContent__D9Mee"};